import { HistoryTransactions } from '@/features/profile-page/HistoryTransactions/ui/HistoryTransactions'
import './ui/HistoryTransactions.css'
export default HistoryTransactions
